import React from "react";
import classNames from "classnames";
import PrimaryButton from "../../elements/primary-button";
import Heading from "../../elements/heading";
import "./style.scss";

const AddToCartBanner = ({
  product: { name = "", price = "" },
  button,
  hide,
  headerIsHidden
}) => {
  return (
    <div
      className={classNames("cart-banner grid", "sticky", {
        hide,
        headerIsHidden
      })}
    >
      <div className="content">
        <div className="product">
          <Heading
            className="cart-banner-title"
            html={{ value: `<span class="type-h4">${name}</span>` }}
          />
          <div className="price">{price}</div>
        </div>

        <PrimaryButton {...button} />
      </div>
    </div>
  );
};

export default AddToCartBanner;
